import { Component, HostBinding } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-my-bets-print-title',
    templateUrl: 'my-bets-print-title.html',
    standalone: false,
})
export class MyBetsPrintTitleComponent {
    @HostBinding('class') className = 'my-bets-print-title';

    constructor(public sitecore: Sitecore) {}
}
